import React from 'react'
import { usePipeline } from '@morningtrain/react-helpers'
import useOnBeforeNavigate from '../hooks/use-on-before-navigate'

export default function TriggerPipelineOnBeforeNavigate () {
  const pipeline = usePipeline()

  useOnBeforeNavigate((routeName, parameters) => {
    const payload = { routeName, parameters }

    return pipeline.trigger(payload)
  })

  return null
}
